/**
 * Created by jonas on 2020-09-17.
 */


import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BS2GameAssets} from "../BS2GameAssets";
import {BS2} from "../BS2";
import {gsap} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {LineWinDisplay} from "../component/LineWinDisplay";
import {BasicBitmapCountUp} from "../component/BasicBitmapCountUp";
import {WinWayDisplay} from "../component/WinWayDisplay";
import {BS2Statics} from "../config/BS2Statics";
import {IBetData} from "../runnerpresentations/maingame/win/WinSummery";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {BS2GameMode} from "../server/BS2GameMode";


export class BS2WinView extends PIXI.Container implements StageLayer {
    public static WIN_COUNT_UP = {
        fontName: BS2GameAssets.BITMAP_FONT_WIN_COUNT_UP,
        fontSize: 285,
        tint: 0xffffff
    }
    private _countUp: BasicBitmapCountUp;
    private _winWaysCountUp: WinWayDisplay;
    private _countContainer: PIXI.Container;
    private countUpLayer: PIXI.Container;
    private winWayLayer: PIXI.Container;
    private _bigWinAnimations: PIXI.spine.Spine[];
    private _bigWinContainer: PIXI.Container;
    private _blackOut: PIXI.Sprite;
    private _maxWinAnimation: PIXI.spine.Spine;
    private _winLineDisplayCont: PIXI.Container;

    constructor() {
        super();
        this.name = "BS2WinView";
        this.init();
    }

    public onResize() {
        const yOffset: number = BS2Statics.getShortScreenOffset();
        const isSsfsPosition: boolean = BS2.model.data.mode === BS2GameMode.FREESPIN_SUPER || BS2.model.data.nextMode === BS2GameMode.FREESPIN_SUPER || BS2.model.data.mode === BS2GameMode.AVALANCHE_FREESPIN_SUPER || BS2.model.data.nextMode === BS2GameMode.AVALANCHE_FREESPIN_SUPER;
        this.position.set(0, isSsfsPosition ? 34 : yOffset);
        this._blackOut.position.set(360, 360 - (isSsfsPosition ? 34 : yOffset));

        this._blackOut.width = NolimitApplication.screenBounds.width;
        this._blackOut.height = NolimitApplication.screenBounds.height;

        //#169
        for (let i: number = 0; i < this._bigWinAnimations.length; i++) {
            NolimitApplication.isLandscape ? this._bigWinAnimations[i].scale.set(1) : this._bigWinAnimations[i].scale.set(0.8);
        }
    }

    public getCountUpScaleAnimation(fromCount: number, toCount: number, duration: number, fromScale: number, toScale: number): gsap.core.Timeline {
        const tl = gsap.timeline();

        tl.add(() => {
            this._countUp.scale.set(fromScale, fromScale);
            this._countUp.preCalculateScale(fromCount, toCount);
        });

        tl.add(gsap.to(this._countUp.scale, {duration: duration, x: toScale, y: toScale, ease: "none"}));

        return tl;
    }

    public getPositionAnimation(duration: number, toPosition: PIXI.Point, ease: string): gsap.core.Timeline {
        const tl = gsap.timeline();

        tl.add(gsap.to(this._countContainer.position, {
            duration: duration,
            x: toPosition.x,
            y: toPosition.y,
            ease: ease
        }));

        return tl;
    }

    public getWinCountUp(from: number, to: number, duration: number, ways: number = 0, pos: PIXI.Point = new PIXI.Point(360, 360), skipSound: boolean = false, shouldPump: boolean = false): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        const winWaysShowDuration: number = duration > 0.3 ? 0.3 : 0.01;
        const winWaysShow: gsap.core.Timeline | undefined = this._winWaysCountUp.getShowAnimation(ways, winWaysShowDuration);
        const pumpAnim: gsap.core.Timeline = gsap.timeline();
        if (shouldPump) {
            pumpAnim.add(gsap.to(this._countContainer.scale, {duration: 0.05, x: 1.2, y: 1.2, ease: "none"}));
            pumpAnim.add(gsap.to(this._countContainer.scale, {duration: 0.3, x: 1, y: 1}));
        }

        tl.add(() => {
            this._countContainer.position.set(pos.x, pos.y);
            this.countUpLayer.addChild(this._countContainer);
        });

        if (!skipSound) {
            tl.add(() => {
                BS2.soundPlayer.startCountUp();
            })
        }

        if (winWaysShow) {
            tl.add([
                this._countUp.getCountAnimation(from, to, duration),
                winWaysShow,
                pumpAnim
            ]);
        } else {
            tl.add([
                this._countUp.getCountAnimation(from, to, duration),
                pumpAnim
            ]);
        }

        tl.add(gsap.to(this._countContainer, {duration: 0.02, alpha: 1, ease: "none"}), 0);


        tl.add(() => {
            this._countUp.stopAt(to, false);
        });


        return tl;
    }

    public getWinCountUpEnd(accumulatedRoundWin: number, stayDuration: number, ways: number = 0, endSound: string = ""): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            BS2.soundPlayer.endCountUp(endSound);
            this.countUpLayer.addChild(this._countContainer);
            this._countUp.stopAt(accumulatedRoundWin, false);
            this._winWaysCountUp.position.set(0, this._countUp.height * 0.5 + 35);
            this._winWaysCountUp.scale.set(this._countUp.scale.x, this._countUp.scale.y);
            if (ways !== 0) {
                this._winWaysCountUp.setWays(ways);
                this._winWaysCountUp.updateFontSize(this._countUp.width);
            }
            this._winWaysCountUp.getShowAnimation(ways, 0.1);
        });
        tl.add(gsap.to(this, {duration: stayDuration}));

        return tl;
    }

    public getWinCountUpFade(accumulatedRoundWin: number, fadeDuration: number = 0.3, stayDuration: number = 0) {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(gsap.to(this, {duration: stayDuration}))

        tl.add([
            gsap.to(this._countContainer, {duration: fadeDuration, alpha: 0, ease: "none"}),
            gsap.to(this._countContainer.position, {
                duration: fadeDuration,
                y: this._countContainer.position.y - 100,
                ease: "none"
            })
        ]);
        tl.add(() => {
            // this._multiplierText.reset();
            this.countUpLayer.removeChild(this._countContainer);
            this._countContainer.position.set(0, 0);
        });

        return tl;
    }

    public getBigWinAnimation(startAnim: string, level: number, duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        let currentLevel: PIXI.spine.Spine | undefined;
        if (level > 1) {
            currentLevel = this._bigWinAnimations[level - 2];
        }
        let nextLevel: PIXI.spine.Spine = this._bigWinAnimations[level - 1];
        if (currentLevel) {
            tl.to(currentLevel!, {duration: 0.1, alpha: 0, ease: "none"}, "<");
            tl.add(() => {
                currentLevel!.visible = false;
            });
        }

        tl.add(() => {
            this._bigWinContainer.visible = true;
            this._bigWinContainer.alpha = 1;
            this._blackOut.alpha = 0.7;

            nextLevel.visible = true;
            nextLevel.alpha = 1;
            nextLevel.updateTransform();
            if (level == 2) {
                nextLevel.state.setAnimation(0, `bw${level}`, false);
            } else {
                nextLevel.state.setAnimation(0, `BW${level}`, false);
            }
        }, 0);

        return tl;
    }

    public getBrokeBankStart(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(gsap.to(this._blackOut, {duration: 1.0, alpha: 1, ease: "none"}));
        tl.add(() => {
            this._bigWinContainer.visible = true;
            this._bigWinContainer.alpha = 1;
            this._maxWinAnimation.visible = true;
            this._maxWinAnimation.alpha = 1;
        })
        tl.add(SpineGSAPWrapper.createTimeline(this._maxWinAnimation, 0, "intro"));
        tl.add(SpineGSAPWrapper.createTimeline(this._maxWinAnimation, 0, "loop", -1));


        return tl;
    }

    public getBrokeBankEnd(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(gsap.to(this._blackOut, {duration: 0.5, alpha: 0, ease: "none"}));
        tl.to(this._maxWinAnimation, {duration: 0.5, alpha: 0, ease: "none"});
        tl.add(() => {
            // this._maxWinAnimation.scale.set(1);
            this._bigWinContainer.alpha = 0;
            this._bigWinContainer.visible = false;
            this._maxWinAnimation.visible = false;
            this._maxWinAnimation.state.setEmptyAnimation(0, 0)
            this._maxWinAnimation.state.clearTracks();
            this._maxWinAnimation.skeleton.setBonesToSetupPose();
            this._maxWinAnimation.skeleton.setSlotsToSetupPose();
        })

        return tl;
    }

    public getBigWinEnd(stayDuration: number = 1): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(gsap.to(this, {duration: stayDuration - 0.3}));
        tl.add(gsap.to(this._bigWinContainer, {duration: 0.3, alpha: 0, ease: "none"}));
        tl.add(gsap.to(this._blackOut, {duration: 0.3, alpha: 0.0, ease: "none"}), "<");

        tl.add(() => {
            this._bigWinContainer.alpha = 0;
            this._bigWinContainer.visible = false;

            for (let i: number = this._bigWinAnimations.length - 1; i >= 0; i--) {
                const bigWin: PIXI.spine.Spine = this._bigWinAnimations[i];
                bigWin.alpha = 0;
                bigWin.visible = false;
            }
        })


        return tl;

    }

    public playLineWinDisplayGroup(data: IBetData): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        const display = new LineWinDisplay(data.betWin);
        display.position.set(BS2Statics.REEL_AREA_X_OFFSET + (BS2Statics.SYMBOL_WIDTH * data.reelPos.column), BS2Statics.REEL_AREA_Y_OFFSET + (BS2Statics.SYMBOL_HEIGHT * data.reelPos.row) + 5);
        display.alpha = 0;
        tl.add(() => {
            this._winLineDisplayCont.removeChildren();
            this._winLineDisplayCont.addChild(display);
        })
        tl.add(display.getAnimation());

        return tl;

    }

    public removeWinLine(): void {
        this._winLineDisplayCont.removeChildren();
    }

    private init() {
        this._countUp = new BasicBitmapCountUp(BS2WinView.WIN_COUNT_UP, 700, new PIXI.Point(0.5, 0.5));
        this._countUp.position.set(0, 0);

        this._winWaysCountUp = new WinWayDisplay();
        this._winWaysCountUp.position.set(0, 110);

        this._blackOut = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._blackOut.name = "blackOut";
        this._blackOut.tint = 0;
        this._blackOut.position.set(360, 360);
        this._blackOut.anchor.set(0.5, 0.5);
        this._blackOut.alpha = 0;


        this._countContainer = new PIXI.Container();
        this._countContainer.name = "_countContainer";
        this._countContainer.alpha = 0;
        this._countContainer.position.set(360, 280);
        this._countContainer.addChild(this._winWaysCountUp, this._countUp);
        this._bigWinContainer = this.createBigWinGraphics();

        this.countUpLayer = new PIXI.Container();
        this.countUpLayer.name = "countUpLayer";
        this.winWayLayer = new PIXI.Container();
        this.winWayLayer.name = "winWayLayer";

        this._winLineDisplayCont = new PIXI.Container();
        this._winLineDisplayCont.position.set(0, 0);
        this._winLineDisplayCont.name = "winLineDisplayCont";


        this.addChild(this._blackOut);
        this.addChild(this._bigWinContainer);
        this.addChild(this.winWayLayer);
        this.addChild(this._winLineDisplayCont);
        this.addChild(this.countUpLayer);

        this.onResize();
    }


    private createBigWinGraphics(): PIXI.Container {
        const container: PIXI.Container = new PIXI.Container();
        container.name = "bigWinContainer";
        container.position.set(360, 360);
        container.alpha = 0;
        container.visible = false;

        this._bigWinAnimations = [
            new PIXI.spine.Spine(BS2.assetLoader.getSpineAsset(BS2GameAssets.BIG_WIN_SPINE_LEVEL_1)),
            new PIXI.spine.Spine(BS2.assetLoader.getSpineAsset(BS2GameAssets.BIG_WIN_SPINE_LEVEL_2)),
            new PIXI.spine.Spine(BS2.assetLoader.getSpineAsset(BS2GameAssets.BIG_WIN_SPINE_LEVEL_3)),
            new PIXI.spine.Spine(BS2.assetLoader.getSpineAsset(BS2GameAssets.BIG_WIN_SPINE_LEVEL_4)),
            new PIXI.spine.Spine(BS2.assetLoader.getSpineAsset(BS2GameAssets.BIG_WIN_SPINE_LEVEL_5))
        ];

        this._maxWinAnimation = new PIXI.spine.Spine(BS2.assetLoader.getSpineAsset(BS2GameAssets.MAX_WIN_SPINE));
        this._maxWinAnimation.name = "maxWin";
        this._maxWinAnimation.visible = false;

        const bigWinSpineContainer: PIXI.Container = new PIXI.Container();
        bigWinSpineContainer.name = "spineContainer";
        bigWinSpineContainer.addChild(this._maxWinAnimation);

        for (let i: number = this._bigWinAnimations.length - 1; i >= 0; i--) {
            const bigWin: PIXI.spine.Spine = this._bigWinAnimations[i];
            bigWin.name = "bigWinLvl_" + (i + 1);
            bigWin.visible = false;
            bigWinSpineContainer.addChild(bigWin);
        }
        container.addChild(bigWinSpineContainer);

        return container;
    }

}